import React from 'react'
import ReactDOM from 'react-dom'
import 'normalize.css'
import './index.css'
import App from './App' 

ReactDOM.render(<App />, document.getElementById('root'))


